import { isPercentage } from "../../utils/formValidation";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
// src/compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal.tsx

import React, { useState } from "react";
import { updateServiceFee, ServiceFee } from "../../services/serviceFeeService";
import "./UpdateServiceFeeModal.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface UpdateServiceFeeModalProps {
  currentPercentage?: number;
  onClose: () => void;
  onSuccess: (updatedFee: ServiceFee) => void;
}

const UpdateServiceFeeModal: React.FC<UpdateServiceFeeModalProps> = ({
  currentPercentage,
  onClose,
  onSuccess,
}) => {
  const [newPercentage, setNewPercentage] = useState(
    currentPercentage?.toString() ?? "",
  );
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    const percentageValue = Number(newPercentage);
    if (!isPercentage(newPercentage)) {
      toast.error(
        "Enter a percentage between 0 and 100.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
      return;
    }

    setLoading(true);
    try {
      const updatedFee = await updateServiceFee(percentageValue);
      toast.success("Service fee updated successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      onSuccess(updatedFee);
    } catch (error) {
      toast.error("Failed to update service fee.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title={<>{currentPercentage === undefined
              ? "Set Service Fee"
              : "Update Service Fee"}</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <main className="modal-body">
          <div className="form-group">
            <label htmlFor="percentage">New Service Fee Percentage (%)</label>
            <input
              type="number" min="0" max="100" step="0.01"
              id="percentage"
              value={newPercentage}
              onChange={(e) => setNewPercentage(e.target.value)}
              placeholder="e.g., 10"
            />
          </div>
        </main>
        <footer className="modal-footer">
          <Button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" variant="primary"
            className="btn btn-primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </footer>
      </div>
</Modal>
  );
};

export default UpdateServiceFeeModal;
